import { fetchData } from "./fetchData";

//get pois using JobID
export const getPOIsAPI = async(jobId) => {
    const route = `/pois?jobid=${jobId}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

//get one POI using POIID
export const getSinglePOIAPI = async(poiId, poiGroupId) => {

    //can choose to include poiGroupId - this return linkedPOI data with the POI
    const route = poiGroupId ? `/pois/${poiId}?groupid=${poiGroupId}` : `/pois/${poiId}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

//create a poi
export const createPOIAPI = async (poiData) => {
    const route = `/pois`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(poiData)
    }

    let response = await fetchData(route, options);

    return response;
}

//update a poi
export const updatePOIAPI = async (poiData) => {
    const route = `/pois`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(poiData)
    }

    let response = await fetchData(route, options);

    return response;
}

//delete a poi with POIID
export const deletePOIByIDAPI = async (poi) => {
    const route = `/pois`;

    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({poi}) 
    }

    let response = await fetchData(route, options);

    return response;
}

/**
 * @description Get POIs with notification data included
 * @param {Number} jobID
 * @param {Number} userID
 */
export const getPOIWithNotificationByJob = async(jobID, userID) => {
    const route = `/pois/notifications?job=${jobID}?user=${userID}`;

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}

/**
 * @description Get POIs with notification data included
 * @param {Number|Number[]} runIDs - Single run ID or array of run IDs
 * @param {Number} jobID
 * @param {Number} userID
 * @param {Number} groupID
 */
export const getPOIWithNotificationByRunAPI = async(runIDs, jobID, userID, groupID) => {
    const runParam = Array.isArray(runIDs) ? runIDs.join(',') : runIDs;
    const route = `/pois/notifications?run=${runParam}&job=${jobID}&user=${userID}&group=${groupID}`;

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}

/**
 * @description Get estimated pass time for a POI
 * @param {Number} poiId
 * @param {Number} runId
 */
export const getPOIEstimatedPassTimeAPI = async(poiId, runId) => {
    const route = `/pois/${poiId}/${runId}`;

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}